import { Link } from "react-router-dom";
import { baseURL, diviceToken } from "../helper/helper";
import { useDispatch } from "react-redux";
import { addToCart } from "../features/cart/cartSlice";

const ProductCardII = ({product}) => {

    const dispatch = useDispatch();

    const handleAddToCart = () => {
        const addToCartProduct = {
            product_id: product?.product?.id,
            qty: 1,
            price: product?.product?.MaxSellingPrice,
            product_type: "product",
            seller_id: 1,
            device_token: diviceToken,
            user_id: ""
        }

        dispatch(addToCart(addToCartProduct))
    }

    return (
        <div>
            <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                <Link
                    to={`/product-details-two/${product?.slug}`}
                    className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                >
                    <span className="product-card__badge bg-main-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                        Sold
                    </span>
                    <img
                        src={ product?.thumbnail_image_source ? `${baseURL}/${product?.thumbnail_image_source}` : "assets/images/thumbs/product-two-img1.png"}
                        alt=""
                        className="w-auto max-w-unset"
                    />
                </Link>
                <div className="product-card__content mt-16">
                    <div className="flex-align gap-6">
                        <span className="text-xs fw-medium text-gray-500">{product?.rating}</span>
                        <span className="text-15 fw-medium text-warning-600 d-flex">
                            <i className="ph-fill ph-star" />
                        </span>
                        <span className="text-xs fw-medium text-gray-500">({product?.reviews?.length})</span>
                    </div>
                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                        <Link
                            to={`/product-details-two/${product?.slug}`}
                            className="link text-line-2"
                            tabIndex={0}
                        >
                            {product?.product_name}
                        </Link>
                    </h6>
                    <div className="flex-align gap-4">
                        <span className="text-tertiary-600 text-md d-flex">
                            <i className="ph-fill ph-storefront" />
                        </span>
                        <span className="text-gray-500 text-xs">
                            By Lucky Supermarket
                        </span>
                    </div>
                    <div className="mt-8">
                        <div
                            className="progress w-100 bg-color-three rounded-pill h-4"
                            role="progressbar"
                            aria-label="Basic example"
                            aria-valuenow={35}
                            aria-valuemin={0}
                            aria-valuemax={100}
                        >
                            <div
                                className="progress-bar bg-tertiary-600 rounded-pill"
                                style={{ width: "35%" }}
                            />
                        </div>
                        <span className="text-gray-900 text-xs fw-medium mt-8">
                            Sold: {product?.total_sale}
                        </span>
                    </div>
                    <div className="product-card__price my-20">
                        <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                            {product?.discount ? `৳${product?.max_sell_price}` : ""}
                        </span>
                        <span className="text-heading text-md fw-semibold ">
                            {
                                product?.discount || product?.max_sell_price ? `৳${product?.max_sell_price - product?.discount}` : `৳${product?.max_sell_price}`
                            }
                            <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                        </span>
                    </div>
                    <Link
                        className="product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                        tabIndex={0}
                        onClick={handleAddToCart}
                    >
                        Add To Cart <i className="ph ph-shopping-cart" />
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ProductCardII;